import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
var Sage = function Sage(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#788590' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.576 10.254c-1.582-.203-6.124-.022-6.124-2.101 0-1.22 1.92-1.899 3.661-1.899a9.353 9.353 0 0 1 5.198 1.492l2.373-2.35C18.984 4.83 16.384 3 12.113 3c-3.887 0-7.39 2.034-7.39 5.288 0 4.995 6.034 4.995 8.543 5.243 1.536.158 2.915.249 2.915 1.74 0 1.401-2.125 2.17-3.774 2.17-2.69 0-4.294-.882-5.876-2.305L4 17.689c2.192 2.125 5.153 3.277 8.203 3.255 4.52 0 7.797-1.99 7.797-5.99 0-2.643-1.785-4.225-5.424-4.7Z",
    fill: color
  }));
};
export default Sage;